import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';

import { AppComponent } from './app.component';
import { CoreModule } from '@no-kno/core/core.module';
import { TenantService } from './core/services/tenant.service';

export function initTenantService(tenantService: TenantService) {
  // must return a function returning Promise<void> (or Observable)
  return () => tenantService.loadConfig();
}

export function getBaseHref(platformLocation: PlatformLocation, tenantService: TenantService) {
  const alias = tenantService.getAliasFromPath(platformLocation.pathname);
  if (!!alias) {
    return `/c/${alias}/`;
  }
  // Default base href if no condition met, or more complex logic
  return '/';
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CoreModule,
    RouterModule,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  bootstrap: [AppComponent],
  providers: [
    TenantService,
    {
      provide: APP_INITIALIZER,
      useFactory: initTenantService,
      deps: [TenantService],
      multi: true,
    },
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseHref,
      deps: [PlatformLocation, TenantService]
    }
  ]
})
export class AppModule { }
